import { makeStyles } from 'tss-react/mui';

const CardStyles = makeStyles()(theme => ({
  card: {
    display: 'flex',
    marginTop: theme.spacing(2),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(0, 0, 0, 0.06)',
    overflow: 'hidden',
  },
  content: {
    flex: '1 0 auto',
    padding: theme.spacing(2),
  },
  cover: { width: 151 },
  error: {
    color: theme.palette.error.main,
    fontWeight: 500,
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    borderLeft: '1px solid rgba(0, 0, 0, 0.06)',
    '&:first-of-type': {
      borderLeft: 'none',
    },
  },
  detailsMiddle: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    borderLeft: '1px solid rgba(0, 0, 0, 0.06)',
    flex: 2,
    minWidth: 0,
  },
  detailsRight: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    borderLeft: '1px solid rgba(0, 0, 0, 0.06)',
    flex: 1.75,
    minWidth: 0,
  },
  media: {
    width: 181,
    backgroundSize: 'cover',
  },
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    boxShadow: theme.shadows[5],
    outline: 'none',
    borderRadius: 8,
  },
  photo: {
    width: 140,
    height: 140,
    margin: theme.spacing(2),
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  label: {
    color: 'rgba(0, 0, 0, 0.5)',
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: theme.spacing(1.5),
  },
  statCard: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderRadius: 8,
    backgroundColor: 'rgba(0, 187, 205, 0.06)',
    border: '1px solid rgba(0, 187, 205, 0.2)',
    textDecoration: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 187, 205, 0.12)',
      transform: 'translateY(-1px)',
    },
  },
  statValue: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#00bbcd',
  },
  statLabel: {
    fontSize: '0.7rem',
    color: 'rgba(0, 0, 0, 0.6)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  bdCompanyCard: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2.5),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderRadius: 8,
    backgroundColor: 'rgba(156, 39, 176, 0.08)',
    border: '1px solid rgba(156, 39, 176, 0.3)',
    textDecoration: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(156, 39, 176, 0.15)',
      transform: 'translateY(-1px)',
    },
  },
  bdCompanyName: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#7b1fa2',
    marginBottom: theme.spacing(0.5),
  },
  roleCard: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(1, 1.5),
    borderRadius: 8,
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
    border: '1px solid rgba(25, 118, 210, 0.3)',
  },
  roleCardAdmin: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(1, 1.5),
    borderRadius: 8,
    backgroundColor: 'rgba(255, 193, 7, 0.15)',
    border: '1px solid rgba(255, 193, 7, 0.5)',
  },
  roleIcon: {
    fontSize: '1.25rem',
    marginRight: theme.spacing(0.75),
  },
  roleLabel: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  sectionCard: {
    marginTop: theme.spacing(2),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(0, 0, 0, 0.06)',
    overflow: 'hidden',
  },
  sectionHeader: {
    fontSize: '1rem',
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  sectionContent: {
    padding: theme.spacing(2.5),
  },
  infoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  infoLabel: {
    color: 'rgba(0, 0, 0, 0.5)',
    fontSize: '0.8125rem',
    minWidth: 140,
    flexShrink: 0,
  },
  infoValue: {
    fontSize: '0.875rem',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
  },
  actionButton: {
    textTransform: 'none',
    borderRadius: 6,
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  statusEnabled: {
    color: '#2e7d32',
    fontWeight: 600,
  },
  statusDisabled: {
    color: '#d32f2f',
    fontWeight: 600,
  },
}));

export default CardStyles;
